import { HttpHeaders } from '@angular/common/http';
import { GatewayDecommission } from './common/models/gatewaydecommission';
import { EpalDecomAndComm } from './common/models/EpalDecomAndComm';
import { EpalCommissionFilter } from './common/models/epalcommissionfilter';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ProvisionFilter } from './common/models/provisionfilter';
import { GatewayFilter } from './common/models/gatewayfilter';
import { GatewayType } from './common/models/gatewaytype';
import { AssignGateway } from './common/models/assigngateway';
import { Commission } from './common/models/commission';
import { UserFilter } from './common/models/userfilter';
import { AddUser } from './common/models/adduser';
import { AppConfigService } from './services/app-config.service';
import { EpalCommission } from './common/models/epalcommission';
import { BIDataProcess } from './common/models/bidataprocess';
import { GatewayFirmware } from './common/models/gatewayfirmware';
import { CPIBFirmware } from './common/models/CPIBFirmware';
import { TwilioPhoneNumber } from './common/models/twilioPhoneNumber';
import { EloviewAppContent } from './common/models/eloviewappcontent';
import { EpalRebootRequest } from './common/models/epalRebootRequest';
import { EloviewDevices } from './common/models/eloviewDevices';
import { AddContentToDevice } from './common/models/addcontenttodevice';
import { ReportsFilter } from './common/models/reportsfilter';
import { UnitAnalyticsResult, UnitAnalyticsCombinedResult } from './common/models/unitAnalytics';
import { CPIBRcnInfo } from './common/models/CpibRcnInfo';
import { EpalGatewayDecommission } from './common/models/epalgatewaydecommission';
import { AssignEpalGateway } from './common/models/assignepalgateway';
import { OtisLinePhonenumber } from './common/models/otislinephonenumber';
import { CPIBTestStationPhNumber } from './common/models/CPIBTestStationPhNumber';
import { ediorderpriority } from './common/models/ediorderpriority';
import { XmlFileId } from './common/models/xmlFileId';
import { spareParts } from './common/models/spareparts';
import { EpalDecommission } from './common/models/epaldecommission';
import { syncGatewayInfo } from './common/models/syncGatewayInfo';
import { UnitSync } from './common/models/unitSync';
import { ediorder } from './common/models/ediOrder';
import { edipartnumbers } from './common/models/edipartnumbers';
import { EloViewSync } from './common/models/eloviewsync';
import { UserPermissionRequest } from './common/models/userpermissionrequest';
import { updateunitdetailsrequest } from './common/models/updateunitdetailsRequest';
import { MasterDataService } from './services/master-data.service';

@Injectable({
  providedIn: 'root'
})
export class Service {
  constructor(private httpClient: HttpClient, private appConfigService: AppConfigService,
    private masterDataService: MasterDataService) { }

  //GET, POST, DELETE File Api's
  getFilesBySearchFilterApi = this.appConfigService.serverUrl + '/api/v1/file/search';
  deleteFileApi = this.appConfigService.serverUrl + '/api/v1/file';
  uploadFileApi = this.appConfigService.serverUrl + '/api/v1/file/upload';
  processFileApi = this.appConfigService.serverUrl + '/api/v1/file/process';
  xmlProcessFileApi = this.appConfigService.serverUrl + '/api/v1/file/xmlprocess';

  //GET, POST Gateway Unit Api's
  getGatewayUnitsBySearchFilterApi = this.appConfigService.serverUrl + '/api/v1/unit/gateway/';
  assignGatewayApi = this.appConfigService.serverUrl + '/api/v1/unit/gatewaycommission';
  updateGatewayfirmwareversionApi = this.appConfigService.serverUrl + '/api/v1/unit/gatewayversionupdate';
  decommissionGatewayApi = this.appConfigService.serverUrl + '/api/v1/unit/gatewaydecommission';
  addGatewayFirmwareApi = this.appConfigService.serverUrl + '/api/v1/unit/GatewayFirmware';
  getGatwayFirmwareVersionApi = this.appConfigService.serverUrl + '/api/v1/unit/GetGatewayFirmware';
  getDigiFirmwareVersionApi = this.appConfigService.serverUrl + '/api/v1/unit/GetDigiFirmwareVersion';
  getBuildingUnitsApi = this.appConfigService.serverUrl + '/api/v1/unit/building';
  getUnitDeviceGatewayApi = this.appConfigService.serverUrl + '/api/v1/unit/GetUnitDeviceGateway';
  bulkXmlUploadApi = this.appConfigService.serverUrl + '/api/v1/unit/bulkuploadunits';
  getDigiFirmwareProgressApi = this.appConfigService.serverUrl + '/api/v1/unit/getgatewayfirmwareprogress';
  checkVerizonDeviceApi = this.appConfigService.serverUrl + '/api/v1/unit/getdeviceinfo';
  checkAttDeviceApi = this.appConfigService.serverUrl + '/api/v1/unit/getattdeviceinfo';

  //GET, POST Commission Unit Api's
  getCommissionUnitsBySearchFilterApi = this.appConfigService.serverUrl + '/api/v1/unit/commissioning/';
  commissionApi = this.appConfigService.serverUrl + '/api/v1/unit/commissioning';
  endcpibtestApi = this.appConfigService.serverUrl + '/api/v1/unit/endcpibtest';
  getunitvvconfigApi = this.appConfigService.serverUrl + '/api/v1/unit/unitvvconfiguration';
  decommissionApi = this.appConfigService.serverUrl + '/api/v1/unit/decommissioning';
  getOtisLinePhNumApi = this.appConfigService.serverUrl + '/api/v1/unit/getotislinephonenumber';
  getUnitsByBuildingIdApi = this.appConfigService.serverUrl + '/api/v1/unit/unitdetails';
  getCPIBFirmwareApi = this.appConfigService.serverUrl + '/api/v1/unit/CPIBFirmwareVersion';
  addCPIBGatewayFirmwareApi = this.appConfigService.serverUrl + '/api/v1/unit/SaveCPIBFirmware';
  getCPIBRunningFirmwareApi = this.appConfigService.serverUrl + '/api/v1/unit/cpibrcn';
  getUnitWriteConfigApi = this.appConfigService.serverUrl + '/api/v1/unit/GetUnitConfigStatus';
  getUnitDetailsApi = this.appConfigService.serverUrl + '/api/v1/unit/building';
  getUnitInfoApi = this.appConfigService.serverUrl + '/api/v1/unit/unitinfo';
  saveOtisLinePhonenumbersapi = this.appConfigService.serverUrl + '/api/v1/unit/otislinephonenumber';
  getUnitVVAlarmApi = this.appConfigService.serverUrl + '/api/v1/unit/GetAlarmHistoryStatus';
  saveTestStationPhonenumberApi = this.appConfigService.serverUrl + '/api/v1/unit/SaveTestStationPhoneNumber';
  getTestStationPhonenumberApi = this.appConfigService.serverUrl + '/api/v1/unit/GetTestStationPhoneNumber';
  deleteTestStationPhonenumberApi = this.appConfigService.serverUrl + '/api/v1/unit/DeleteTestStationPhoneNumber';
  getGatewayDeviceStatusApi = this.appConfigService.serverUrl + '/api/v1/unit/GatewayDeviceStatus';

  //GET, POST, DELETE User Mangement  Api's
  getUsersApi: string = this.appConfigService.serverUrl + '/api/v1/user/search';
  userApi = this.appConfigService.serverUrl + '/api/v1/user';
  getUserPermissionsApi: string = this.appConfigService.serverUrl + '/api/v1/user/getuserpermissions';
  updateUserPermissionsApi = this.appConfigService.serverUrl + '/api/v1/user/updateuserpermissions';

  //GET G3MS Unit data Api's
  getG3MSUnitDetailsApi = this.appConfigService.serverUrl + '/api/v1/unit/g3ms';

  //GET G3MS Unit data Api's
  getBiProvisionSearchApi = this.appConfigService.serverUrl + '/api/v1/unit/SearchBIUnit';
  processBIUnitApi = this.appConfigService.serverUrl + '/api/v1/unit/BIUnitProvision';


  //GET Twilio phone number data Api's
  getSearchTwilioPhoneNumberApi = this.appConfigService.serverUrl + '/api/v1/unit/SearchTwilioPhoneNumber';
  purchaseTwilioPhoneNumber = this.appConfigService.serverUrl + '/api/v1/unit/PurchaseTwilioPhoneNumber';
  releaseTwilioPhoneNumber = this.appConfigService.serverUrl + '/api/v1/unit/ReleaseTwilioPhoneNumber';


  //EloView Api's
  getAppContentApi = this.appConfigService.serverUrl + '/api/v1/epal/EloViewAppContent';
  getEloViewDevicesApi = this.appConfigService.serverUrl + '/api/v1/epal/EloViewDevices';
  getEloSerialNumbersApi = this.appConfigService.serverUrl + '/api/v1/epal/geteloserialnumbers';
  getEloInfoApi = this.appConfigService.serverUrl + '/api/v1/epal/geteloviewinfo';
  getePALCommissionedDevicesApi = this.appConfigService.serverUrl + '/api/v1/epal/GetFCCommissionedEloDevices';
  getBuildingDetailsBySearchFilterApi = this.appConfigService.serverUrl + '/api/v1/epal/search';
  getBuildingUnitDeatilsByePalHwIdApi = this.appConfigService.serverUrl + '/api/v1/epal/buildingunits';

  ePALCommissionApi = this.appConfigService.serverUrl + '/api/v1/epal/commission';
  addContentToDeviceApi = this.appConfigService.serverUrl + '/api/v1/epal/InstallContentToDevice';
  rebootEloViewDeviceApi = this.appConfigService.serverUrl + '/api/v1/epal/RebootDevice';
  ePALDeCommissionApi = this.appConfigService.serverUrl + '/api/v1/epal/decommission';
  syncEloInfoApi = this.appConfigService.serverUrl + '/api/v1/epal/synctoeloview';
  ePALDecomAndCommissionApi = this.appConfigService.serverUrl + '/api/v1/epal/DecommAndCommEpalHwID';

  ePALAssignGatewayApi = this.appConfigService.serverUrl + '/api/v1/epal/AssignEpalGateway';
  getEpalGatewayInfoByBuildingIdApi = this.appConfigService.serverUrl + '/api/v1/epal/EpalGatewayInfo';
  ePALGatewayDeCommissionApi = this.appConfigService.serverUrl + '/api/v1/epal/DecommissionEpalGateway';
  //GET Reports Api's
  getunitsReportApi = this.appConfigService.serverUrl + '/api/v1/unit/UnitsReport';
  getAnalyticsApi = this.appConfigService.serverUrl + '/api/v1/analytics/getanalytics';
  getXMLLogsApi = this.appConfigService.serverUrl + '/api/v1/unit/xmllogs';

  //GET EDI Orders Data Api's
  getEDIOrdersApi = this.appConfigService.serverUrl + '/api/v1/ediorder/orderdetails';
  getEDIPOOrderDetailsApi = this.appConfigService.serverUrl + '/api/v1/ediorder/getpoorderdetails';
  getEDIPartNumbersApi = this.appConfigService.serverUrl + '/api/v1/ediorder/getpartnumbers';

  //GET Unit History Api's
  getUnitHistoryApi = this.appConfigService.serverUrl + '/api/v1/unit/unithistory';

  //EDI Order Priority Api's
  uploadEDIOrderApi = this.appConfigService.serverUrl + '/api/v1/ediorder/upload';
  getEDIOrderDetailsApi = this.appConfigService.serverUrl + '/api/v1/ediorder/GetEDIOrderInfo';
  eDIOrderDetailsUpdateApi = this.appConfigService.serverUrl + '/api/v1/ediorder/updatepriority';

  //Spare Parts
  getSparePartsDetailsApi = this.appConfigService.serverUrl + '/api/v1/ediorder/getsparepartsdetails'
  saveSparePartsDetailsAPI = this.appConfigService.serverUrl + '/api/v1/ediorder/savespareparts'
  addSparePartAPI = this.appConfigService.serverUrl + '/api/v1/ediorder/addsparepart';

  //Gateway Sync
  getGatewayInfoBySearchFilterApi = this.appConfigService.serverUrl + '/api/v1/unit/getgatewayinfo/';
  syncgatewayinfo = this.appConfigService.serverUrl + '/api/v1/unit/syncgatewayinfo';

  //Provisioning Sync
  getUnitSyncApi = this.appConfigService.serverUrl + '/api/v1/unit/getunitsyncdetails/';
  syncUnitInfo = this.appConfigService.serverUrl + '/api/v1/unit/unitsync/';
  getBuildingUnitDetailsAPI = this.appConfigService.serverUrl + '/api/v1/unit/getbuildingunitdetails/';
  updatebuildingunitdetailsAPI = this.appConfigService.serverUrl + '/api/v1/unit/updatebuildingunitdetails';

  //User Permissions
  userPermissionApi = this.appConfigService.serverUrl + '/api/v1/user/getUserPermission';

  userInfo = {};

  getFileDataOnLoad(filterBody: ProvisionFilter) {
    return this.httpClient.post(this.getFilesBySearchFilterApi, filterBody).
      pipe(catchError(error => throwError(() => error)))
  }

  getFilesByFilterSearch(filterBody: ProvisionFilter) {
    return this.httpClient.post(this.getFilesBySearchFilterApi, filterBody).
      pipe(catchError(error => throwError(() => error)))
  }

  uploadFile(fileToUpload: File, deviceTypeId: number, highRiseNewEqp: boolean, elevatorTypeId: number,
    deviceTypeId2: number, invokeProcess: boolean, chkAuxUnit: boolean, primaryContentTypeId: number, auxDevicesCount: number,
    aux1ContentTypeId: number, aux2ContentTypeId: number, aux3ContentTypeId: number) {
    const formData: FormData = new FormData();
    formData.append('formFile', fileToUpload, fileToUpload.name);
    return this.httpClient.post(this.uploadFileApi + "?deviceTypeId=" + deviceTypeId + "&uiUpload=true&highRiseNewEqp=" + highRiseNewEqp + "&elevatorTypeId=" + elevatorTypeId + "&deviceTypeId2=" + deviceTypeId2 + "&invokeProcess=" + invokeProcess
      + "&isAuxUnit=" + chkAuxUnit + "&primaryContentTypeId=" + primaryContentTypeId + "&auxDevicesCount=" + auxDevicesCount + "&aux1ContentTypeId=" + aux1ContentTypeId + "&aux2ContentTypeId=" + aux2ContentTypeId + "&aux3ContentTypeId=" + aux3ContentTypeId, formData)
  }

  deleteFile(id: number) {
    return this.httpClient.delete(this.deleteFileApi + "/" + id).
      pipe(catchError(error => throwError(() => error)))
  }

  processFile(idList: number[]) {
    return this.httpClient.post(this.processFileApi, idList).
      pipe(catchError(error => throwError(() => error)))
  }

  processXMLFile(fileId: XmlFileId) {
    return this.httpClient.post(this.xmlProcessFileApi, fileId).
      pipe(catchError(error => throwError(() => error)))
  }

  bulkUpload(unitNumbers: string) {
    return this.httpClient.post(this.bulkXmlUploadApi + "?unitNumbers=" + unitNumbers, unitNumbers)
  }

  getUnitsByFilterSearch(filterBody: GatewayFilter) {
    return this.httpClient.get(this.getGatewayUnitsBySearchFilterApi + filterBody.searchField).
      pipe(catchError(error => throwError(() => error)))
  }

  addCPIBGatewayFirmware(requestBody: CPIBFirmware) {
    return this.httpClient.post(this.addCPIBGatewayFirmwareApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  getCPIBRunningFirmware(CPIBMacAddress: string) {
    return this.httpClient.get(this.getCPIBRunningFirmwareApi + "?cpibMacAddress=" + CPIBMacAddress).
      pipe(catchError(error => throwError(() => error)))
  }

  getCPIBFirmware() {
    return this.httpClient.get(this.getCPIBFirmwareApi).
      pipe(catchError(error => throwError(() => error)))
  }

  assignGateway(requestBody: AssignGateway) {
    return this.httpClient.post(this.assignGatewayApi, requestBody).
      pipe(
        map((data: any) => { return data; }),
        catchError(error => throwError(() => error))
      )
  }

  updateFirmwareVersioninDRM(requestBody: AssignGateway) {
    return this.httpClient.post(this.updateGatewayfirmwareversionApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  getDigiFirmwareVersion(gatewayMacAddress: any) {
    return this.httpClient.get(this.getDigiFirmwareVersionApi + '?gatewayMacAddress=' + gatewayMacAddress).
      pipe(catchError(error => throwError(() => error)))
  }

  getFirmwareProgress(gatewayMacAddress: any) {
    return this.httpClient.get(this.getDigiFirmwareProgressApi + '?gatewayMacAddress=' + gatewayMacAddress).
      pipe(catchError(error => throwError(() => error)))
  }

  getCommissionUnitsByFilterSearch(srchUnitNumber: any) {
    return this.httpClient.get(this.getCommissionUnitsBySearchFilterApi + srchUnitNumber).
      pipe(catchError(error => throwError(() => error)))
  }

  startCPIBTest(requestBody: Commission) {
    return this.httpClient.post(this.commissionApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  endCPIBTest(requestBody: Commission) {
    return this.httpClient.post(this.endcpibtestApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  getunitvvconfiguration(unitnumber: string, elevatorDeviceId: number) {
    return this.httpClient.get(this.getunitvvconfigApi + "?unitnumber=" + unitnumber + "&elevatorDeviceId=" + elevatorDeviceId).
      pipe(catchError(error => throwError(() => error)))
  }

  deCommissioning(requestBody: Commission) {
    return this.httpClient.patch(this.decommissionApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  getUsers(requestBody: UserFilter) {
    return this.httpClient.post(this.getUsersApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  AddUser(requestBody: AddUser) {
    return this.httpClient.post(this.userApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  userStatusChange(id: number, status: string, aadObjId: string) {
    return this.httpClient.patch(this.userApi + "/" + id + "/" + status + "/" + aadObjId, "").
      pipe(catchError(error => throwError(() => error)))
  }

  userRoleUpdate(id: number, roleId: number) {
    return this.httpClient.patch(this.userApi + "/" + roleId + "/" + id, "").
      pipe(catchError(error => throwError(() => error)))
  }

  getUserDetails(id: string) {
    return this.httpClient.get(this.userApi + "/" + id).
      pipe(
        map((data: any) => { this.userInfo = data; return data; }),
        catchError(error => throwError(() => error))
      )
  }

  getG3MSUnitData(txtG3MSSrch: string) {
    return this.httpClient.get(this.getG3MSUnitDetailsApi + "/" + txtG3MSSrch).
      pipe(catchError(error => throwError(() => error)))
  }

  getOtisLinePhonenumbers() {
    return this.httpClient.get(this.getOtisLinePhNumApi).
      pipe(catchError(error => throwError(() => error)))
  }

  getBuildingDetailsByFilterSearch(filterBody: EpalCommissionFilter) {
    return this.httpClient.post(this.getBuildingDetailsBySearchFilterApi, filterBody).
      pipe(catchError(error => throwError(() => error)))
  }

  getUnitDetailsByBuildingId(buildingId: string) {
    return this.httpClient.get(this.getUnitsByBuildingIdApi + "?buildingId=" + buildingId).
      pipe(catchError(error => throwError(() => error)))
  }

  getEpalGatewayInfoByBuildingId(buildingId: string) {
    return this.httpClient.get(this.getEpalGatewayInfoByBuildingIdApi + "?buildingId=" + buildingId).
      pipe(catchError(error => throwError(() => error)))
  }

  getePALCommissionedDevices(buildingId: string) {
    return this.httpClient.get(this.getePALCommissionedDevicesApi + "?buildingId=" + buildingId).
      pipe(catchError(error => throwError(() => error)))
  }

  ePALCommissioning(requestBody: EpalCommission) {
    return this.httpClient.post(this.ePALCommissionApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  ePALDeCommissioning(epaldecommission: EpalDecommission) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: epaldecommission
    };
    return this.httpClient.delete(this.ePALDeCommissionApi, httpOptions).
      pipe(catchError(error => throwError(() => error)))
  }

  ePALDeCommAndCommission(requestBody: EpalDecomAndComm) {
    return this.httpClient.post(this.ePALDecomAndCommissionApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  ePALGatewayDeCommission(decommission: EpalGatewayDecommission) {
    return this.httpClient.delete(this.ePALGatewayDeCommissionApi + "?gatewayMacAddress=" + decommission.gatewayMacAddress + "&buildingId=" + decommission.buildingId + "&deviceGatewayTypeId=" + decommission.deviceGatewayTypeId).
      pipe(catchError(error => throwError(() => error)))
  }

  getBuildingUnitDetailsByePALHwId(ePAlHwId: string) {
    return this.httpClient.get(this.getBuildingUnitDeatilsByePalHwIdApi + "?EpalHardwareId=" + ePAlHwId).
      pipe(catchError(error => throwError(() => error)))
  }

  getBIProvisionUnitBySearch(elevatorUnitNumber: string) {
    const data = [];
    return this.httpClient.get(this.getBiProvisionSearchApi + "?ElevatorUnitNumber=" + elevatorUnitNumber).
      pipe(
        map((response: any) => { data[0] = response; return data; }),
        catchError(error => throwError(() => error))
      )
  }

  BIUnitProcess(requestBody: BIDataProcess) {
    return this.httpClient.post(this.processBIUnitApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  gatewayDeCommission(requestBody: GatewayDecommission) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: requestBody
    };
    return this.httpClient.delete(this.decommissionGatewayApi, httpOptions).
      pipe(catchError(error => throwError(() => error)))
  }
  addGatewayFirmware(requestBody: GatewayFirmware) {
    return this.httpClient.post(this.addGatewayFirmwareApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  getGatewayFirmwareVersion() {
    return this.httpClient.get(this.getGatwayFirmwareVersionApi).
      pipe(catchError(error => throwError(() => error)))
  }

  public isAdmin(): boolean {
    return (this.userInfo["role"] !== null && this.userInfo["role"] !== undefined && this.userInfo["role"].toUpperCase().trim() === "ADMIN")
  }

  getSearchTwilioPhoneNumber(areaCode: string, countryCode: string, region: string, unitNumber: string) {
    return this.httpClient.get(this.getSearchTwilioPhoneNumberApi + "?countryCode=" + countryCode
      + "&areaCode=" + areaCode + "&region=" + region + "&unitNumber=" + unitNumber).
      pipe(catchError(error => throwError(() => error)))
  }

  PurchaseTwilioPhoneNumber(requestBody: TwilioPhoneNumber) {
    return this.httpClient.post(this.purchaseTwilioPhoneNumber, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  ReleaseTwilioPhoneNumber(requestBody: TwilioPhoneNumber) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: requestBody
    };
    return this.httpClient.delete(this.releaseTwilioPhoneNumber, httpOptions).
      pipe(catchError(error => throwError(() => error)))
  }

  getEloViewAppContent(selEloVersionNumber: number = 3) {
    return this.httpClient.get(this.getAppContentApi + "?selectedEloVersion=" + selEloVersionNumber).
      pipe(catchError(error => throwError(() => error)))
  }

  getEloViewDevices(eloViewSerialNumber: string, lblMdlBldId: string, selEloVersionNumber: number) {
    return this.httpClient.get(this.getEloViewDevicesApi + "?eloViewSerialNumber=" + eloViewSerialNumber + "&buildingId=" + lblMdlBldId + "&selectedEloVersion=" + selEloVersionNumber).
      pipe(catchError(error => throwError(() => error)))
  }

  addContentToDevice(requestBody: AddContentToDevice) {
    return this.httpClient.patch(this.addContentToDeviceApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  eloViewDeviceReboot(requestBody: EpalRebootRequest) {
    return this.httpClient.post(this.rebootEloViewDeviceApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  getAnalytics(filterType: string, startDate: string, endDate: string) {
    const url = filterType === 'ALL'
      ? `${this.getAnalyticsApi}?filterType=${filterType}`
      : `${this.getAnalyticsApi}?filterType=${filterType}&startDate=${startDate}&endDate=${endDate}`;
    return this.httpClient.get<UnitAnalyticsCombinedResult>(url).pipe(
      map((data: UnitAnalyticsCombinedResult) => data),
      catchError(error => throwError(() => error))
    );
  }

  getUnitDetailsReport(reportsfilter: ReportsFilter) {
    return this.httpClient.get(this.getunitsReportApi + "?fileType=" + reportsfilter.fileType + "&fromDate=" + reportsfilter.createdFromDate + "&toDate=" + reportsfilter.createdToDate).
      pipe(catchError(error => throwError(() => error)))
  }

  getXMLLogs(fromDate: string, toDate: string) {
    return this.httpClient.get(this.getXMLLogsApi + "?startDate=" + fromDate + "&endDate=" + toDate).
      pipe(catchError(error => throwError(() => error)))
  }

  getUnitDeviceGatewayType(unitNumber: string) {
    return this.httpClient.get(this.getUnitDeviceGatewayApi + "?unitNumber=" + unitNumber).
      pipe(catchError(error => throwError(() => error)))
  }

  getBuildingUnits(unitNumber: string) {
    return this.httpClient.get(this.getBuildingUnitsApi + "?unitNumber=" + unitNumber).
      pipe(catchError(error => throwError(() => error)))
  }

  getCPIBWriteConfigStatus(ElevatorUnitNumber: string, deckType: string) {
    return this.httpClient.get(this.getUnitWriteConfigApi + "?unitNumber=" + ElevatorUnitNumber + "&deckType=" + deckType).
      pipe(catchError(error => throwError(() => error)))
  }

  getVVAlarmStatus(ElevatorUnitNumber: string, CountryCode: string, ElevatorDeviceId: number) {
    return this.httpClient.get(this.getUnitVVAlarmApi + "?unitNumber=" + ElevatorUnitNumber + "&CountryCode=" + CountryCode + "&ElevatorDeviceId=" + ElevatorDeviceId).
      pipe(catchError(error => throwError(() => error)))
  }

  ePALAssignGateway(requestBody: AssignEpalGateway) {
    return this.httpClient.post(this.ePALAssignGatewayApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  getUnitInfo(ElevatorUnitNumber: string) {
    return this.httpClient.get(this.getUnitInfoApi + "?unitNumber=" + ElevatorUnitNumber).
      pipe(catchError(error => throwError(() => error)))
  }

  saveOtisLinePhonenumbers(requestBody: OtisLinePhonenumber) {
    return this.httpClient.post(this.saveOtisLinePhonenumbersapi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  saveTestStationOtisLinePh(requestBody: CPIBTestStationPhNumber) {
    return this.httpClient.post(this.saveTestStationPhonenumberApi, requestBody).
      pipe(catchError(error => throwError(() => error)))
  }

  deleteTestStationOtisLinePh() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.httpClient.delete(this.deleteTestStationPhonenumberApi, httpOptions).
      pipe(catchError(error => throwError(() => error)))
  }

  getTestStationOtisLinePh() {
    return this.httpClient.get(this.getTestStationPhonenumberApi).
      pipe(catchError(error => throwError(() => error)))
  }

  getEDIOrdersData(txtEdiOrdersPOSrch: string, txtEdiOrdersUNSrch: string, txtEdiOrdersONSrch: string) {
    return this.httpClient.get(this.getEDIOrdersApi + "?PONumber=" + txtEdiOrdersPOSrch + "&UnitNumber=" + txtEdiOrdersUNSrch + "&OrderNumber=" + txtEdiOrdersONSrch).
      pipe(catchError(error => throwError(() => error)))
  }

  getUnitHistory(txtUnitSrch: string) {
    return this.httpClient.get(this.getUnitHistoryApi + "?unitNumber=" + txtUnitSrch).
      pipe(catchError(error => throwError(() => error)))
  }

  uploadEDIPriorityFile(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('formFile', fileToUpload, fileToUpload.name);
    return this.httpClient.post(this.uploadEDIOrderApi, formData)
  }

  getEDIOrdersPrirorityData() {
    return this.httpClient.get(this.getEDIOrderDetailsApi).
      pipe(catchError(error => throwError(() => error)))
  }

  updateEDIPriorityData(PriorityRowData: ediorderpriority[]) {
    return this.httpClient.patch(this.eDIOrderDetailsUpdateApi, PriorityRowData)
  }

  getSparePartsData() {
    return this.httpClient.get(this.getSparePartsDetailsApi).
      pipe(catchError(error => throwError(() => error)))
  }

  saveUpdateSpareParts(sparePartsInfo: spareParts) {
    return this.httpClient.post(this.saveSparePartsDetailsAPI, sparePartsInfo).
      pipe(catchError(error => throwError(() => error)))
  }

  getGatewayDeviceStatus(gatewaySerialNumber: any, gatewayType: any) {
    return this.httpClient.get(this.getGatewayDeviceStatusApi + '?gatewayMacAddress=' + gatewaySerialNumber + "&gatewayType=" + gatewayType).
      pipe(catchError(error => throwError(() => error)))
  }

  getEDIPartNumbers() {
    return this.httpClient.get(this.getEDIPartNumbersApi).
      pipe(catchError(error => throwError(() => error)))
  }

  getPOOrderDetails() {
    return this.httpClient.get(this.getEDIPOOrderDetailsApi).
      pipe(catchError(error => throwError(() => error)))
  }

  addSparePart(ediOrder: ediorder) {
    return this.httpClient.post(this.addSparePartAPI, ediOrder).
      pipe(catchError(error => throwError(() => error)))
  }

  getGatewayUnitsByFilterSearch(searchText: string, filterType: number) {
    return this.httpClient.get(this.getGatewayInfoBySearchFilterApi + '?searchText=' + searchText + "&filterType=" + filterType).
      pipe(catchError(error => throwError(() => error)))
  }

  checkUserPermission() {
    return this.httpClient.get(this.userPermissionApi).
      pipe(catchError(error => throwError(() => error)))
  }

  insertGatewaySyncInfo(syncInfo: syncGatewayInfo) {
    return this.httpClient.patch(this.syncgatewayinfo, syncInfo).
      pipe(catchError(error => throwError(() => error)))
  }

  getUnitSyncInfo(unitNumber: string) {
    return this.httpClient.get(this.getUnitSyncApi + '?unitNumber=' + unitNumber).
      pipe(catchError(error => throwError(() => error)))
  }

  unitSyncInfo(unitSyncInfo: UnitSync) {
    return this.httpClient.post(this.syncUnitInfo, unitSyncInfo).
      pipe(catchError(error => throwError(() => error)))
  }
  getEloViewInfo(searchText: string, filterType: number) {
    return this.httpClient.get(this.getEloInfoApi + '?searchText=' + searchText + "&filterType=" + filterType).
      pipe(catchError(error => throwError(() => error)))
  }

  syncEloViewInfo(eloViewSync: EloViewSync) {
    return this.httpClient.patch(this.syncEloInfoApi, eloViewSync).
      pipe(catchError(error => throwError(() => error)))
  }

  getUserPermissions(userId: number) {
    return this.httpClient.get(this.getUserPermissionsApi + '?userId=' + userId).
      pipe(catchError(error => throwError(() => error)))
  }

  updateUserPermissions(userPermissionReq: UserPermissionRequest) {
    return this.httpClient.patch(this.updateUserPermissionsApi, userPermissionReq).
      pipe(catchError(error => throwError(() => error)))
  }

  getUnitBuildingDetails(searchFilter: string) {
    return this.httpClient.get(this.getBuildingUnitDetailsAPI + '?searchUnitInfoDetails=' + searchFilter).
      pipe(catchError(error => throwError(() => error)))
  }

  updateUnitBuildingDetails(selectedUnitDetails: updateunitdetailsrequest) {
    return this.httpClient.put(this.updatebuildingunitdetailsAPI, selectedUnitDetails).
      pipe(catchError(error => throwError(() => error)))
  }

  checkVerizonDevice(simCardIccId: string) {
    return this.httpClient.get(this.checkVerizonDeviceApi + "?simIccId=" + simCardIccId).
      pipe(catchError(error => throwError(() => error)))
  }

  checkATTDeviceStatus(simCardIccId: string) {
    return this.httpClient.get(this.checkAttDeviceApi + "?simIccId=" + simCardIccId).
      pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          return throwError(error);
        })
      )
  }
}
